import { ROSQuestionnaire } from '../../../../../../lib/Questionnaires'
import { CheckboxInput, TextInput } from '../../../../../shared/FormBuilder'

function Hematologic ({ disabled }) {
  return (
    <div className='row margin-top'>
      <div className='col-xs-12 col-sm-4 col-md-3'>
        <CheckboxInput
          disabled={disabled}
          {...ROSQuestionnaire.hematologicPetechia}
        />
      </div>
      <div className='col-xs-12 col-sm-4 col-md-3'>
        <CheckboxInput
          disabled={disabled}
          {...ROSQuestionnaire.hematologicExcessiveBleeding}
        />
      </div>
      <div className='col-xs-12 col-sm-4 col-md-3'>
        <CheckboxInput
          disabled={disabled}
          {...ROSQuestionnaire.hematologicBruising}
        />
      </div>
      <div className='col-xs-12 margin-top'>
        <CheckboxInput
          disabled={disabled}
          {...ROSQuestionnaire.hematologicOther}
        />
      </div>
      <div className='col-xs-12'>
        <TextInput
          disabled={disabled}
          {...ROSQuestionnaire.hematologicOtherText}
        />
      </div>
    </div>
  )
}

export default Hematologic
